import { jwtDecode } from 'jwt-decode';

export const actions = {
  async fetchUser() {
    const token = localStorage.getItem('access_token');
    const decoded = jwtDecode(token);

    this.me = {
      auth_id: decoded.auth_id,
      resource_access: decoded.resource_access,
      merchant: decoded.merchant,
      preferred_username: decoded.preferred_username,
      store: decoded.store,
      name: decoded.name,
    };
  },
};
